export default {
    lang: 'por',
    header: {
        official_website: 'Sítio web oficial',
        user_enter: 'Centro Do Utilizador',
        sign_out: 'Sair',
        language: 'Portuguese'
    },
    aside: {
        dash_board: 'Painel',
        knowledge_base: 'Utilizar documentação',
        my_order: 'A minha encomenda',
        purchase_subscription: 'Compra',
        node_status: 'Estado do Nodo',
        subscribe: 'Compra',
        finance: 'finanças',
        user: 'usuário',
        order_details: 'Detalles da ordem'
    },
    orders: {
        order_number: '# Número da encomenda',
        cycle: 'Ciclo',
        order_amount: 'Valor do pedido',
        order_status: 'Estado da encomenda',
        to_be_paid: 'Aguardando pagamento',
        cancelled: 'Utilizador cancelar',
        timeOut: "Cancelar automaticamente quando expirar",
        fail: 'Falha no pagamento',
        completed: 'Pagamento bem sucedido',
        creation_time: 'Tempo de criação',
        operate: 'operação',
        check_the_details: 'Ver detalhes',
        cancel: 'Cancelar',
        cancel_message: 'Se você já fizer o pagamento, cancelar a ordem pode resultar em falha de pagamento. Você tem certeza de que quer cancelar a ordem?',
        Attention: "Atenção",
        sure: 'Confirmar',
        refunded: 'Reembolsado',
        processing: 'Durante o processamento',
        chargeback: 'Chargeback',
        unknown: 'desconhecido',
        cancel_payment: 'Cancelar pagamento'
    },
    personal: {
        change_password: 'Alterar palavra-passe',
        old_password: 'Senha antiga',
        please_enter_old_password: 'Digite a senha antiga',
        new_password: 'Nova palavra-passe',
        please_enter_a_new_password: 'Introduza uma nova palavra-passe',
        save: 'salvar',
        reset_subscription_information: 'Redefinir informações de compra',
        reset_message: 'Quando o seu endereço de compra ou conta é vazado e abusado por outros, você pode redefinir suas informações de compra aqui.Evitar Perdas desnecessárias.',
        reset: 'repor',
        change_subscription_info: 'Se seu endereço ou informação de compra estiver comprometido, você pode realizar essa operação. Depois de reiniciar, seu UUID e compra mudarão e você precisa importar sua compra novamente.',
        sure_subscription: 'Você tem certeza de que quer reiniciar a informação de compra?'
    },
    document: {
        title: 'Descarga do cliente (tutorial)',
        v2rayNG: {
            name: '📱 Cliente Android - v2rayNG',
            step1: '① Por favor, compre primeiro',
            step1_content1: 'Compra',
            step2: '② Copie o endereço url do nó',
            step2_content1: 'Após a conclusão da compra, clique em compra de um clique e copiar o link de compra',
            step2_content2: 'Copiar link de compra',
            step3: '③ Baixe e instale o cliente Android-v2rayNG',
            step3_content1: 'Clique para baixar',
            step4: '④ Insira as configurações de compra do nó',
            step4_content1: '- Abra V2rayNG e clique no canto superior esquerdo para expandir mais opções',
            step4_content2: '- Clique Em "Configurar grupo de compra"',
            step5: '⑤Configurar compra',
            step5_content1: '- Depois de inserir as configurações de compra, clique em " + " no canto superior direito para entrar na página de Configurações do nó',
            step5_content2: '- remarks: preencha o nome personalizado',
            step5_content3: '- URL opcional: insira o endereço url do nó colado na etapa ② ',
            step5_content4: 'Clique em "√" no canto superior direito para concluir a configuração',
            step6: '⑥ Atualizar compra',
            step6_content1: '- Volte à página principal e clique em": "no canto superior direito ',
            step6_content2: '- Selecione "Renovar compra"',
            step6_content3: '- As informações do nó serão exibidas na página principal',
            step7: '⑦Comece a usar',
            step7_content1: '- Escolha qualquer nó',
            step7_content2: '- Clique no logotipo cinza " V " no canto inferior direito da página inicial e, quando o logotipo cinza ficar verde, a conexão será bem-sucedida e a Internet será ligada.',
        },
        Clash_for_Windows: {
            name: '💻 Cliente Windows - Clash for Windows',
            step1: '① Por favor, compre primeiro',
            step1_content1: 'Compra',
            step2: '② Copie o endereço url do nó',
            step2_content1: 'Após a conclusão da compra, clique em compra de um clique e copiar o link de compra',
            step2_content2: 'Copiar link de compra',
            step3: '③ Baixe e instale o cliente Windows-Clash Para Windows',
            step3_content1: 'Clique para baixar',
            step4: '④ Configurar o Clash Para Windows',
            step4_content1: '- Abra o Clash Para Windows, insira Profiles na barra lateral, insira o URL copiado na etapa ② e clique no botão Download',
            step4_content2: '- Insira Proxies, selecione Rule na parte superior e, em seguida, selecione seu nó favorito no grupo de políticas abaixo.',
            step4_content3: '- Em seguida, volte para General na barra lateral e verifique System Proxy (definido como Proxy do sistema) abaixo.',
        },
        Shadowrocket: {
            name: '🍎 Cliente IOS - Shadowrocket',
            step1: '① Por favor, compre primeiro',
            step1_content1: 'comprar',
            step2: '② Copie o endereço url do nó',
            step2_content1: 'Após a conclusão da compra, clique em compra de um clique e copiar o link de compra',
            step2_content2: 'Copiar link de compra',
            step3: '③ Baixe e instale o cliente iOS-Shadowrocket',
            step3_content1: 'Clique para baixar',
            step4: '④ Configurar compra',
            step4_content1: '- Abra a página inicial do Shadowrocket, clique em " + "no canto superior direito, clique novamente em" Type " na primeira linha e selecione o link Compra.',
            step4_content2: '- Digite MuteNet em "Remarks", cole o link de compra abaixo em" URL " e salve-o.',
            step4_content3: '- Em seguida, clique em Salvar no canto superior direito, e o servidor de aquisição será atualizado automaticamente neste momento.',
            step4_content4: '- Volte para a página inicial e clique para entrar em "Global Routing" para alterá-lo para configuração.',
        },
        FoXray: {
            name: '🍎 Cliente IOS - FoXray',
            step1: '① Por favor, compre primeiro',
            step1_content1: 'comprar',
            step2: '② Copie o endereço url do nó',
            step2_content1: 'Após a conclusão da compra, clique em compra de um clique e copiar o link de compra',
            step2_content2: 'Copiar link de compra',
            step3: '③ Baixe e instale o cliente iOS-FoXray',
            step3_content1: 'Clique para baixar',
            step4: '④ Configurar compra',
            step4_content1: '- Abra a página inicial da FoXray e clique em "Compras" na parte inferior',
            step4_content2: '- Na página" Compras", clique em " + " no canto superior direito',
            step4_content3: '- Nome: introduza um nome personalizado',
            step4_content4: '- URL: insira o link de compra do URL copiado na etapa ② ',
            step4_content5: 'Clique em "Add" na parte inferior para concluir a configuração',
        },
        Official:{
            name:'📱 Cliente oficial do Android',
            step1:'① Por favor, compre primeiro',
            step1_content1:'Compra',
            step2:'② Baixe e instale o cliente oficial do Android',
            step2_content1:'Clique para baixar',
            step3:'③uso do cliente oficial',
            step3_content1:'Depois de baixar e concluir a instalação do cliente de opinião, abra-o e você verá a interface de login do cliente.Introduza o seu número de conta e palavra-passe MuteNet e poderá iniciar sessão directamente no cliente.Depois de iniciar sessão, clique em ligar para começar a utilizar os nossos serviços.',
        }
    },
    pannel: {
        used: 'Usado',
        total: 'Total',
        announcement: 'Anúncio',
        my_subscription: 'A minha Comprar',
        expires_on: 'Expira em',
        expiration: 'dias restantes até a expiração',
        shortcut: 'Atalho',
        view_tutorial: 'Ver tutorial',
        learn: 'Saiba como utilizar o MuteNet',
        quick_subscription: 'Assinatura com um clique',
        quick_import: 'Importe rapidamente o nó para o cliente correspondente para uso',
        renew_subscription: 'Assinatura de renovação',
        renew_your_current_subscription: 'Renovar sua assinatura atual',
        encounter_problems: 'Encontrar problemas',
        communicate: "Se você encontrar algum problema, você pode se comunicar conosco através do E-mail: service{'@'}mutenet.world ",
        copy: 'Copiar endereço da Comprar',
        qr: 'Digitalize o código QR para Compra',
        usage: 'Se você não sabe como usá-lo, verifique o tutorial de uso.',
    },
    subscription: {
        choose: 'Por favor escolher o pacote que melhor lhe convier',
        all: 'Todos',
        by_cycle: 'Por ciclo',
        by_traffic: 'Por tráfego',
        order: 'Encomende agora',
        payment_cycle: 'Ciclo de pagamento',
        monthly_payment: 'Pagamento mensal',
        quarterly_payment: 'Pagamento trimestral',
        annual_fee: 'Pagamento anual',
        order_total: 'Valor total da encomenda',
        total: 'Total',
        place_an_order: 'Faça um pedido',
        commodity_information: 'Informação sobre mercadorias',
        product_name: 'Nome do produto',
        type: 'Tipo/Período',
        method: 'Método de pagamento',
        checkout: 'Checkout',
        configure_subscription: 'Configure compra',
        payment_currency: 'Moeda de pagamento',
        order_number: 'Número da encomenda',
        order_information: 'Informação de Ordem',
        creation_time: 'Tempo de criação',
        phone_number: 'Número de telefone',
        area_code: 'Código de área',
        first_name: 'Nome',
        last_name: 'Apelido',
        email: 'Caixa de correio',
        order_payment_failed: 'Falha no pagamento da encomenda',
        order_canceled: 'Pedido cancelado',
        hans_sucess: 'A encomenda foi paga e aberta',
        view_tutorial: 'Ver o tutorial',
        order_timeout: 'A ordem expirou',
        order_expired: 'Ordem expirada',
        cancel_payment: 'Cancelar pagamento',
        order_status_unknown: 'Estado da encomenda desconhecido',
        order_chargeback: 'Chargeback da encomenda',
        order_in_process: 'A encomenda está a ser processada',
        order_has_been_refunded: 'A encomenda foi reembolsada',
        other_subscripe:"Espera-se que o pacote entre em vigor em",
    },
    nodes: {
        name: 'Nome',
        state: 'Situação',
        magnification: 'Ampliação',
        label: 'Rótulo',
        state_title: 'O estado em linha do nó no prazo de cinco minutos',
        magnification_title: 'O tráfego utilizado será multiplicado pela ampliação para dedução'
    },
    login: {
        tip: 'Explore o mundo de forma mais segura e fiável',
        email: 'Caixa de correio',
        password: 'Palavra-passe',
        verification_code: 'Código de verificação',
        login: 'Entrar',
        register: 'Registar',
        forget: 'Esqueceu palavra-passe',
    },
    register: {
        username: 'Nome de utilizador',
        email_code: 'Código de verificação de E-mail',
        send: 'Enviar',
        agree: 'Eu li e concordo com o Contrato de Licença do Usuário',
        register: "Registar",
        return_login: 'Voltar ao login'
    },
    prompt: {
        picture_code: 'Preencha primeiro o código de verificação da imagem',
        username_error: 'Nome de utilizador errado',
        email_err: 'Erro no formato do E-mail',
        password_err: 'A palavra-passe não pode estar vazia',
        email_code_err: 'O código de verificação de E-mail não pode estar vazio',
        Registration_success: 'Enviado com sucesso',
        Sent_successfully: 'Sent successfully',
        Mistake: 'Erro',
        Success: 'Sucesso',
        all_not_empty: 'O endereço de E-mail, a palavra-passe e o código de verificação da imagem do utilizador não podem estar vazios',
        password_diff: 'A palavra-passe introduzida duas vezes é diferente',
        password_change_success: 'A senha foi modificada com sucesso',
        reset_successful: 'Redefinir com sucesso',
        reset_password: 'Redefinir palavra-passe',
        enter_discount_code: 'Introduzir o código do cupão',
        verify: 'verificar',
        invalid_discount_code: 'Código de cupão inválido',
        cancel_success: 'Cancelar com sucesso',
        paying: 'Processamento do pagamento',
        cancel_order: 'Você ainda tem pedidos inacabados sob este produto. Você precisa cancelar antes de comprar. Tem a certeza de que pretende cancelar a encomenda anterior?',
        confirm_order_cancellation: 'Confirmar o cancelamento da encomenda',
        close_order: 'Ordem fechada',
        no_order: 'Atualmente não há informação de ordem disponível',
        no_currencies: 'Atualmente não há informação sobre moeda de pagamento disponível',
        has_subscripe:'Você já tem um pacote disponível e o pacote recém-adquirido entrará em vigor após o pacote disponível expirar. Você confirma sua compra?',
        pass_rule:"As senhas devem conter uma combinação de letras e números em minúsculas, e caracteres especiais podem ser usados",
        pass_rule_err:'Erro no formato da senha',
    },
    docx: {
        title:'Acordo de licença de usuário',
        tip_date:'Última data de atualização: 1 de agosto de 2023',
        tip1:'introdução',
        tip1_content1:'Bem-vindos à Mute Net (a seguir denominado "este produto")! O propósito deste Acordo de Licença de Utilizador (a seguir denominado "Acordo") é estabelecer a relação entre você (a seguir denominado "Utilizador" ou "Você") e GENTRY ELECTRIC CO., LIMITED (a seguir denominada "Companhia"), e esclarecer as condições de utilização deste produto. A menos que você aceite todos os termos deste acordo, você não tem direito de se inscrever, se inscrever ou usar os serviços abrangidos por este acordo. Seu registro, registro, uso e outras ações serão consideradas como aceitação deste acordo, e você concorda em estar vinculado pelos termos deste acordo. Este acordo estipula os direitos e obrigações da Mute Net e do Utilizador em relação aos Serviços (a seguir denominados "Serviços"). O usuário "refere-se a indivíduos que se registam, entram e utilizam este serviço. A Mute Net tem o direito de atualizar os termos do acordo. Uma vez que os termos atualizados do acordo sejam publicados, eles substituirão os termos originais do acordo sem mais aviso.',
        tip2:'Registo de contas',
        tip2_content1:'1. Os usuários precisam registrar uma e apenas uma conta "Mute Net" antes de usar este serviço. A conta "Mute Net" deve ser registada usando a ligação de correio electrónico. Os usuários são solicitados para registar a conta "Mute Net" usando um correio electrónico que não foi ligado a outras contas "Mute Net" ou não foi proibido pela Mute Net de acordo com este acordo. A Mute Net reserva-se o direito de fazer mudanças no registro da conta e métodos vinculativos baseados nas necessidades do usuário ou nas necessidades do produto sem mais aviso.',
        tip2_content2:'2. Se o requerente de registo tem um precedente de ser proibido pela Mute Net, é suspeito de falso registo e uso abusivo do nome de outra pessoa, regista mais de uma conta, ou usa um endereço de correio-electrónico temporário disponível para registo, ou outras razões que não podem ser concedidas permissão, a Mute Net tem o direito de recusar-se a prestar serviços a eles.',
        tip2_content3:'3. A Mute Net observou que registar e utilizar a Mute Net por cidadãos de certos países (como a República Popular da China, a República Islâmica do Irão, a República de Cuba, a República Democrática da Coreia, etc.) serão considerados uma violação da lei. A Mute Net não recomenda aos cidadãos desses países que registrem ou utilizem nossos serviços, nem recomenda aos cidadãos de qualquer outro país que registrem ou comprem serviços da Mute Net enquanto residem nesses países. Por favor, consulte o artigo 2.o da declaração da empresa para mais detalhes.',
        tip3:'Segurança da conta',
        tip3_content1:'1. Uma vez que o usuário se registe com sucesso e se torna um usuário da rede silenciosa, eles receberão um nome de usuário e uma senha, e terão o direito de usar seu próprio nome de usuário e senha para se inscrever na rede silenciosa em qualquer momento.',
        tip3_content2:"2. Os usuários são plenamente responsáveis pela segurança de suas contas e senhas, bem como por todas as atividades e eventos realizados com suas contas.",
        tip3_content3:"3. A Mute Net não deve divulgar privacidade pessoal e informação dos usuários sem sua autorização.",
        tip3_content3_1:"1) Se a segurança da senha do usuário for ameaçada por fuga de senha ou por qualquer outra razão, elas devem contactar imediatamente o pessoal do serviço de cliente Mute Net, caso contrário elas suportarão as perdas correspondentes.",
        tip4:'Declaração e Garantia do Utilizador',
        tip4_content1:'1. Os usuários devem ter plena capacidade civil e a capacidade de entrar em transações e cumprir suas obrigações.',
        tip4_content2:"2. Qualquer serviço fornecido pela Mute Net que os usuários Compra só é aplicável ao próprio usuário. Os usuários não podem compartilhar sua conta, ligação, endereço de Comprar ou outra informação que resulte em múltiplos usuários compartilhando o serviço em qualquer plataforma de qualquer forma.",
        tip4_content3:"3. Qualquer conteúdo criado, enviado, copiado, publicado ou disseminado pelos usuários através do uso da Mute Net, incluindo mas não limitado a avatares de contas, nomes, instruções de usuário e outros materiais de registro e autenticação, bem como texto, voz, imagens, vídeos e páginas de ligação conexas, bem como outros conteúdos gerados pelo uso da conta ou desse serviço, Não deve violar as leis e regulamentos da região/país do usuário ou da República Federativa do Brasil, incluindo, mas não limitados aos seguintes princípios: opor aos princípios básicos estabelecidos pela constituição",
        tip4_content3_a:"a. Atenção à segurança nacional, vazamento de segredos nacionais, subvalorização do poder nacional e minação da unidade nacional",
        tip4_content3_b:"b. Danos à honra e interesses nacionais",
        tip4_content3_c:"c. Incitar ódio étnico, discriminação e minar a unidade étnica",
        tip4_content3_d:"d. Disrupir políticas religiosas nacionais, promover cultos e superstições feudais",
        tip4_content3_e:"e. Espalhar rumores, perturbar a ordem social e perturbar a estabilidade social",
        tip4_content3_f:"f. Espalhar obscenidade, pornografia, jogos de azar, violência, homicídio, terror ou incentivar crimes",
        tip4_content3_g:"g. Insultar ou desafiar outros, violar seus direitos e interesses legítimos",
        tip4_content3_h:"h. Contém outros conteúdos proibidos por leis e regulamentos administrativos",
        tip4_content4:'4. Os usuários não devem usar sua conta "Mute Net" ou esse serviço para criar, enviar, copiar, publicar ou disseminar conteúdo que interfere com operações normais, ou violar os direitos e interesses legítimos de outros usuários ou terceiros: conteúdo que contém qualquer implicação sexual ou sexual',
        tip4_content4_a:"a. Contém insultos, intimidação e ameaças",
        tip4_content4_b:"b. Contém assédio, publicidade spam, informação maliciosa e informação enganadora",
        tip4_content4_c:"c. Involhar a privacidade, informação pessoal ou dados de outros",
        tip4_content4_d:"d. Infração de direitos legítimos como reputação, retrato, propriedade intelectual e segredos comerciais de outros",
        tip4_content4_e:"e. Contém informações que interferem com o funcionamento normal deste serviço e violam os direitos e interesses legítimos de outros usuários ou terceiros.",
        tip5:"conteúdo de serviço",
        tip5_content1:"1. O conteúdo específico de serviço da Mute Net será fornecido pela Mute Net de acordo com a situação real,",
        tip5_content2:"2. Anúncios e outras mensagens aos usuários podem ser enviados através de email ou informações de contato fornecidas pelo usuário.",
        tip6:"Política de Privacidade",
        tip6_content1:"Você concorda que a empresa coleta, usa e processa sua informação pessoal de acordo com sua política de privacidade. Por favor leia a política de privacidade nos termos de uso da empresa para informações detalhadas.",
        tip7_content1:"Actualizar e apoiar",
        tip7_content2:"A empresa pode fornecer atualizações e atualizações deste produto de vez em quando para fornecer novas características, melhorar o desempenho e corrigir vulnerabilidades. Você concorda em receber automaticamente essas atualizações, e a empresa não é responsável por quaisquer problemas causados pelas atualizações.",
        tip8:"Desclamações",
        tip8_content1:"1. Este produto é fornecido como está e sem garantias express as ou implícitas, incluindo mas não limitadas a garantias de comerciabilidade, adequação para fins específicos e não infracção.",
        tip8_content2:"2. A empresa 2 não deve ser responsável por nenhuma perda direta ou indireta causada pelo uso deste produto, incluindo, mas não limitada a perda de dados, perda de lucro, interrupção de negócios, etc.",
        tip9:"terminação",
        tip9_content1:"A empresa reserva-se o direito de terminar sua licença de uso em qualquer momento se você violar qualquer um dos termos deste acordo. Após terminação, você vai deixar de usar este produto e eliminar todos os conteúdos e dados relacionados a este produto.",
        tip10:"Lei aplicável e resolução de litígios",
        tip10_content1:"1. Este acordo será governado pelas leis da Região Administrativa Especial de Hong Kong. Qualquer disputa deve primeiro ser resolvida através de consultas amigáveis entre ambas as partes.",
        tip10_content2:"2. Se a consulta falhar, o litígio será submetido aos tribunais da Região Administrativa Especial de Hong Kong e resolvido de acordo com suas regras de arbitragem.",
        tip11:"Mudança de acordo",
        tip11_content1:"A empresa reserva-se o direito de modificar esse acordo em qualquer momento. O acordo atualizado terá efeito hoje. Ao continuar a usar este produto, você aceita o acordo revisto.",
    },
    state: {
        no_state: 'Nenhum nó disponível, se você não tiver feito uma compra ou se expirou, por favor ',
        order: 'faça a sua compra'
    }

}